import { withRBAC } from "../../rbac";
import { DepartmentCreate } from "./Create";
import { DepartmentEdit } from "./Edit";
import { DepartmentList } from "./List";
import { DepartmentShow } from "./Show";

export const departments = {
  list: withRBAC(DepartmentList, "view_hr"),
  show: withRBAC(DepartmentShow, "view_hr"),
  create: withRBAC(DepartmentCreate, "manage_hr"),
  edit: withRBAC(DepartmentEdit, "manage_hr"),
  recordRepresentation: "name",
};
